module.exports = __webpack_public_path__ + "media/images/coorum_icon_name-8af9a0d60ca1fb7937ef102f2de30926.svg";